import React, { Component } from "react";
import { Helmet } from "react-helmet";
import PageBack from "../../Assets/Images/pageBack.png";
//architecture image
import Architecture1Chi from "../../Assets/Images/aboutUs/architecture1Chi.jpg";
import Architecture1Eng from "../../Assets/Images/aboutUs/architecture1Eng.jpg";
import Architecture2 from "../../Assets/Images/aboutUs/architecture2.jpg";
import Architecture3Chi from "../../Assets/Images/aboutUs/architecture3Chi.jpg";
import Architecture3Eng from "../../Assets/Images/aboutUs/architecture3Eng.jpg";
//strategy image
import StrategyChi0 from "../../Assets/Images/aboutUs/strategyChi0.jpg";
import StrategyChi1 from "../../Assets/Images/aboutUs/strategyChi1.jpg";
import StrategyChi2 from "../../Assets/Images/aboutUs/strategyChi2.jpg";
import StrategyChi3 from "../../Assets/Images/aboutUs/strategyChi3.jpg";
import StrategyChi4 from "../../Assets/Images/aboutUs/strategyChi4.jpg";

import StrategyEng0 from "../../Assets/Images/aboutUs/strategyEng0.jpg";
import StrategyEng1 from "../../Assets/Images/aboutUs/strategyEng1.jpg";
import StrategyEng2 from "../../Assets/Images/aboutUs/strategyEng2.jpg";
import StrategyEng3 from "../../Assets/Images/aboutUs/strategyEng3.jpg";
import StrategyEng4 from "../../Assets/Images/aboutUs/strategyEng4.jpg";

import StrategyImg0 from "../../Assets/Images/aboutUs/strategyImg0.jpg";
import StrategyImg1 from "../../Assets/Images/aboutUs/strategyImg1.jpg";
import StrategyImg2 from "../../Assets/Images/aboutUs/strategyImg2.jpg";
import StrategyImg3 from "../../Assets/Images/aboutUs/strategyImg3.jpg";
import StrategyImg4 from "../../Assets/Images/aboutUs/strategyImg4.jpg";

import Language from "../languageComponent/language";
//const fontColor = {eng:"#171d22", chi:"#171d22"};
const StrategyChi = [StrategyChi0, StrategyChi1, StrategyChi2, StrategyChi3, StrategyChi4];
const StrategyEng = [StrategyEng0, StrategyEng1, StrategyEng2, StrategyEng3, StrategyEng4];
const StrategyImg = [StrategyImg0, StrategyImg1, StrategyImg2, StrategyImg3, StrategyImg4];

class AboutUs extends Component {
  constructor(props) {
    super(props);
    this.state = { siteDimensions: {}, strategyDimensions: {}, imageCount: 0, strategyCount: 0 };
    this.onStrategyImageLoad = this.onStrategyImageLoad.bind(this);
    this.swapStrategy = this.swapStrategy.bind(this);
    setInterval(this.swapStrategy, 1000);
  }
  render() {
    return (
      <div className="container-fluid">
        <Helmet>
          <title>CAC MCRD About Us</title>
          <meta property="og:url" content={"https://cacmcrd.netlify.app/AboutUs"} />
          <meta property="og:type" content={"organization infomation"} />
          <meta property="og:title" content={">CAC MCRD About Us"} />
          <meta property="og:description" content={"Everything about CAC MCRD."} />
          <meta property="og:image" content={Architecture1Chi} />
        </Helmet>
        <div className="background-image">
          <img
            onLoad={this.onImageLoad}
            style={{
              width: "100%",
              height: "100%",
            }}
            src={PageBack}
          />
        </div>
        <div className="site-content">
          <div className="separator"></div>
          <div className="history">
            <p style={{ position: "relative", width: "100%", textAlign: "left", fontSize: "6vh", fontWeight: "bold" }}>
              <Language language={this.props.language} section="historyTitle" />
            </p>
            <p style={{ position: "relative", width: "100%", textAlign: "left", fontSize: "3vh", lineHeight: "4vh" }}>
              <Language language={this.props.language} section="historyContent" />
            </p>
          </div>
          <div className="separator"></div>
          <div className="line-separator" />
          <div className="whoWeAre">
            <p style={{ position: "relative", width: "100%", textAlign: "left", fontSize: "6vh", fontWeight: "bold" }}>
              <Language language={this.props.language} section="whoWeAreTitle" />
            </p>
            <p style={{ position: "relative", width: "100%", textAlign: "left", fontSize: "3vh", lineHeight: "4vh" }}>
              <Language language={this.props.language} section="whoWeAreContent" />
            </p>
          </div>
          <div className="separator"></div>
          <div className="line-separator"></div>
          <div className="purpose">
            <p style={{ position: "relative", width: "100%", textAlign: "left", fontSize: "6vh", fontWeight: "bold" }}>
              <Language language={this.props.language} section="purposeTitle" />
            </p>
            <p style={{ position: "relative", width: "100%", textAlign: "left", fontSize: "3vh", lineHeight: "4vh" }}>
              <Language language={this.props.language} section="purposeContent" mode="list" />
            </p>
          </div>
          <div className="separator"></div>
          <div className="line-separator"></div>
          <div className="architecture" style={{ display: "flex", flexDirection: "column" }}>
            <p style={{ position: "relative", width: "100%", textAlign: "left", fontSize: "6vh", fontWeight: "bold" }}>
              <Language language={this.props.language} section="architectureTitle" />
            </p>
            <p style={{ position: "relative", width: "100%", textAlign: "left", fontSize: "3vh", lineHeight: "4vh" }}>
              <Language language={this.props.language} section="architectureMCRD" />
            </p>
            <img style={{ alignSelf: "center", width: this.props.orientation == "landscape" ? "40vw" : "90vw", marginBottom: "50px" }} src={this.props.language == "chi" ? Architecture1Chi : Architecture1Eng} alt="Architecture1" />
            <span>&nbsp;&nbsp;</span>
            <p style={{ position: "relative", width: "100%", fontSize: "3vh", lineHeight: "4vh" }}>
              <Language language={this.props.language} section="architectureDistributionBranchHeading" />
            </p>
            <p style={{ position: "relative", width: "100%", left: "30px", textAlign: "left", fontSize: "3vh", lineHeight: "4vh" }}>
              <Language language={this.props.language} section="architectureDistributionBranch" />
            </p>
            <img style={{ alignSelf: "center", marginTop: "30px", marginBottom: "50px", width: this.props.orientation == "landscape" ? "80%" : "120%" }} src={Architecture2} alt="Architecture2" />
            <span>&nbsp;&nbsp;</span>
            <p style={{ position: "relative", width: "100%", textAlign: "left", fontSize: "3vh", lineHeight: "4vh" }}>
              <Language language={this.props.language} section="architectureIncidentCommandSystem" />
            </p>
            <img style={{ alignSelf: "center", width: this.props.orientation == "landscape" ? "40vw" : "90vw", marginBottom: "50px" }} src={this.props.language == "chi" ? Architecture3Chi : Architecture3Eng} alt="Architectur3" />
          </div>
          <div className="separator"></div>
          <div className="line-separator"></div>
          <div className="strategy" style={{ display: "flex", flexDirection: "column" }}>
            <p style={{ position: "relative", width: "100%", textAlign: "left", fontSize: "6vh", fontWeight: "bold", lineHeight: "50px" }}>
              <Language language={this.props.language} section="strategyTitle" />
            </p>
            <div style={{ display: "flex", flexDirection: "row", flexWrap: "wrap", justifyContent: "space-evenly" }}>
              <img style={{ alignSelf: "center", width: "45vh", marginTop: "50px" }} src={this.props.language == "chi" ? StrategyChi[this.state.strategyCount] : StrategyEng[this.state.strategyCount]} alt="Strategy" />
              <div className="strategy-image" style={{ display: "flex", alignSelf: "center", width: "60vh", height: "50vh", marginTop: "50px" }}>
                <img onLoad={this.onStrategyImageLoad} style={{ alignSelf: "center", height: this.state.strategyDimensions.height_width_ratio * document.getElementsByClassName("strategy-image").offSetWidth, width: "100%" }} src={StrategyImg[this.state.strategyCount]} />
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
  onStrategyImageLoad({ target: source }) {
    this.setState({
      strategyDimensions: {
        height: source.height,
        width: source.width,
        height_width_ratio: source.height / source.width,
      },
    });
  }
  swapStrategy = (e) => {
    this.setState({
      strategyCount: this.state.strategyCount < 4 ? this.state.strategyCount + 1 : 0,
    });
  };
}
export default AboutUs;
